import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, getToken } from '../../api';

const STORAGE_KEY = 'profile_read_shown';

export default function ProfileRead() {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!getToken()) { navigate('/login'); return; }
    if (localStorage.getItem(STORAGE_KEY)) { navigate('/matches', { replace: true }); return; }

    api.get('/profile/read')
      .then(data => { setText(data.text); setLoading(false); })
      .catch(() => { setFailed(true); setLoading(false); });
  }, [navigate]);

  const proceed = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    navigate('/matches', { replace: true });
  };

  if (loading) {
    return (
      <div style={{ height: '100vh', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span className="spinner" />
      </div>
    );
  }

  return (
    <div className="profile-read-screen">
      <div className="profile-read-label">Paula read your profile.</div>
      {failed ? (
        <p className="profile-read-text" style={{ color: 'var(--muted)' }}>
          Your answers have been saved. Paula will have your full read ready when you check back.
        </p>
      ) : (
        <>
          <p className="profile-read-text">{text}</p>
          <p style={{ fontSize: 13, color: 'var(--gold)', fontFamily: 'var(--font-display)', fontStyle: 'italic', marginTop: 16, marginBottom: 32 }}>
            — Paula
          </p>
        </>
      )}
      <button className="btn btn-gold" style={{ maxWidth: 260 }} onClick={proceed}>
        See your matches →
      </button>
    </div>
  );
}
